import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VolumeFileLoaderService {
  async loadArrayBuffer(
    url: string,
    signal: AbortSignal,
    label: string
  ): Promise<ArrayBuffer> {
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      signal
    });

    this.assertResponse(response, label);

    return response.arrayBuffer();
  }

  async loadText(
    url: string,
    signal: AbortSignal,
    label: string
  ): Promise<string> {
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      signal
    });

    this.assertResponse(response, label);

    return response.text();
  }

  private assertResponse(
    response: Response,
    label: string
  ): void {
    if (response.ok) {
      return;
    }

    let reason: string;

    switch (response.status) {
      case 401:
        reason = 'authentification requise';
        break;

      case 403:
        reason = 'URL interdite ou expirée';
        break;

      case 404:
        reason = 'fichier introuvable';
        break;

      case 410:
        reason = 'URL expirée';
        break;

      default:
        reason = response.statusText || 'erreur HTTP';
    }

    throw new Error(
      `${label} : ${reason} (HTTP ${response.status}).`
    );
  }
}
